module.exports = __webpack_public_path__ + "static/img/1.b8d9daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/1.png
// module id = 5cA+
// module chunks = 1